import type { ChildIssueType, ChildIssueTypeWithFields } from './types';

// A collection of issue fields which are marked as `required`
// for the creation of an issue, but are considered as 'provided' since
// the data for these fields is supplied by Jira.
const providedRequiredFields = ['summary', 'issuetype', 'parent', 'project'];

const isRequiredFieldProvided = (fieldName: string) =>
	providedRequiredFields.find((providedFieldName) => fieldName === providedFieldName);

// A field is considered 'unsupported' if not provided by Jira,
// has no default value, and is a `required` field.
// @ts-expect-error - TS2304 - Cannot find name 'FieldMeta'.
const hasUnsupportedRequiredField = (fields: { [key: string]: FieldMeta }) =>
	!!Object.keys(fields).find(
		(fieldName) =>
			!isRequiredFieldProvided(fieldName) &&
			!fields[fieldName].hasDefaultValue &&
			fields[fieldName].required,
	);

export const transformIssueType = (
	issueType: ChildIssueTypeWithFields,
	epicLinkFieldKey: string | null,
): ChildIssueType => {
	const { fields, ...otherProps } = issueType;
	const hasRequiredField = fields ? hasUnsupportedRequiredField(fields) : false;
	// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
	const hasEpicLinkField = fields ? Object.keys(fields).includes(epicLinkFieldKey) : false;
	return {
		...otherProps,
		hasRequiredField,
		hasEpicLinkField,
	};
};
